class ProductModal extends ModalDialog {
  constructor() {
    super()
  }

  hide() {
    super.hide()
    window.pauseAllMedia()
  }

  show(opener) {
    super.show(opener)
    this.showActiveMedia()
  }

  showActiveMedia() {
    this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`).forEach((element) => {
        element.classList.remove('active')
      },
    )
    const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`)
    activeMedia.classList.add('active')
    activeMedia.scrollIntoView()

    if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
      activeMedia.loadContent()
  }
}

customElements.define('product-modal', ProductModal)

class OptionalPDPModal extends HTMLElement {
  constructor() {
    super()

    this.dontShowModalCheckbox = document.querySelector('#show_modal')
    this.productId = this.dontShowModalCheckbox.dataset.productId
    this.triggerBtn = document.querySelectorAll('.optional-modal')
    this.confirmChoice = document.querySelector('.confirm-choice')

    this.confirmChoice.addEventListener('click', (e) => {
      document.body.classList.remove('overflow-hidden')
      this.removeAttribute('open')
      document.querySelector('[id^="ModalClose-"]').click()
    })

    this.formTrigger?.addEventListener('click', this.onClickTrigger.bind(this))

    this.dontShowModalCheckbox.addEventListener('change', (e) => {
      const optionalPDPModal = document.querySelector('optional-pdp-modal')
      if (e.target.checked) {
        const expiration = document.querySelector('.optional-pdp-modal').dataset.setExpiration
        const timeToExpire = Date.now() + parseInt(expiration) * 24 * 60 * 60 * 1000

        localStorage.setItem('dont-show-modal', timeToExpire)
        optionalPDPModal.dataset.isExpired = false

      } else {
        localStorage.removeItem('dont-show-modal')
        optionalPDPModal.dataset.isExpired = true
      }
    })

    this.checkIfExpired()
  }

  onClickTrigger(e) {
    if (document.querySelector('.product__info-container #rbr-container-element-true')) {
      document.querySelector('.rbr-bap-new-footer')?.click()
    } else {
      this.closest('form')?.dispatchEvent(new Event('CUSTOM_SUBMIT'))
    }
  }

  checkIfExpired() {
    const modalStorageInfo = localStorage.getItem('dont-show-modal')
    const data = JSON.parse(modalStorageInfo)

    if (modalStorageInfo != null) {
      Date.now() > parseInt(modalStorageInfo) ? this.dataset.isExpired = true : this.dataset.isExpired = false
    } else {
      this.dataset.isExpired = true
    }
  }

  get formTrigger() {
    return this.querySelector('.js-form-trigger')
  }
}

customElements.define('optional-pdp-modal', OptionalPDPModal)

class CustomRcWidget extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('keydown', this.onKeyUp.bind(this))
  }

  onKeyUp (event) {
    if (document.activeElement?.classList.contains('select-arrow-active')) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') this.firstOption?.focus()

      if (event.code == 'Escape') this.closeDropdown()
    }
    if (this.isDropdownOpened()) {
      this.toggleFocusable(true)
    } else {
      this.toggleFocusable(false)
    }

    if (event.target.closest('.select-items')) {
      if (event.code == 'Enter') {
        event.target.click()
        setTimeout(() => {
          this.selectTrigger?.focus()
        }, 100)
      }

      if (event.code == 'Tab' && this.isDropdownOpened()) event.preventDefault()

      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') this.focusTrap(event)

      if (event.code == 'Escape') this.closeDropdown()
    }
  }

  toggleFocusable (focus=true) {
    this.selectOptions?.querySelectorAll('[data-label]').forEach(element => {
      if (focus) {
        element.setAttribute('tabindex', 0)
      } else {
        element.setAttribute('tabindex', -1)
      }
    })
  }

  closeDropdown () {
    this.selectOptions?.classList.add('select-hide')
    this.selectTrigger?.classList.remove('select-arrow-active')
    this.selectTrigger?.focus()
  }

  focusTrap (event) {
    event.preventDefault()

    const target = event.target
    if (event.code === 'ArrowUp' && target !== this.firstOption) {
      target.previousSibling?.focus()
    } else if (event.code == 'ArrowDown' && event.target !== this.lastOption) {
      target.nextSibling?.focus()
    }
  }

  isDropdownOpened () {
    return this.selectTrigger?.classList.contains('select-arrow-active')
  }

  get firstOption () {
    return this.querySelector('.select-items [data-label]:first-child')
  }

  get lastOption () {
    return this.querySelector('.select-items [data-label]:last-child')
  }

  get selectTrigger () {
    return this.querySelector('.rc_widget__option__plans .select-selected')
  }

  get selectOptions () {
    return this.querySelector('.rc_widget__option__plans .select-items')
  }
}

customElements.define('custom-rc-widget', CustomRcWidget)

function saveRecentProducts () {
  const maxCount = 10
  let savedHandles = window.getRecentProductHandles(maxCount)

  if (!savedHandles.includes(window.productHandle)) savedHandles.push(window.productHandle)
  if (savedHandles.length > maxCount) savedHandles.slice(0, maxCount)
  window.setCookie('RECENT_PRODUCTS', JSON.stringify(savedHandles))
}
saveRecentProducts()

const updatesQuantity = () => {
  const qtyInputs = document.querySelector('.product__quantity-btns-wrapper quantity-input');
  const formQty = document.querySelector('product-form input[name="quantity"]')
  
  if (qtyInputs && formQty) {
    qtyInputs.addEventListener('click', ()=> {
      const inputVal = qtyInputs.querySelector('input[name="quantity"]');
      formQty.value = inputVal.value
    })
  }
}
updatesQuantity()